import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import basestyles from "../../../shared/styles/basestyles.module.css";
import styles from "../../../patient/pages/Appointments/appointments.module.css";
import Textarea from "../../../shared/components/Textarea/Textarea";
import Input from "../../../shared/components/Input/Input";
import Button from "../../../shared/components/Button/Button";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";
import DoctorsNearby from "../../../shared/components/DoctorsNearby/DoctorsNearby";
import searchbar from "../../../shared/components/SearchBar/searchbar.module.css";
import RecordBtn from "../../../shared/components/Button/RecordBtn";
import Modal from "react-modal";

const initialState = {
  Name: "",
  Age: "",
  Phone: "",
  TypeOfProblemHeSheIsFacing: "",

  NameError: "",
  AgeError: "",
  PhoneError: "",
  TypeOfProblemHeSheIsFacingError: "",

  checked: false,
};

class EmergencyAppointments extends Component {
  state = {
    initialState,
    modalIsOpen: false,
  };

  openModal = (e) => {
    e.preventDefault();
    this.setState({ modalIsOpen: true });
  };
  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  inputchange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  changeCheckedStatus = () => {
    this.setState((prevState) => {
      return {
        checked: !prevState.checked,
      };
    });
  };

  componentDidMount() {
    if (!localStorage.getItem("emergency-appointment")) {
      localStorage.setItem(
        "emergency-appointment",
        JSON.stringify({ data: [] })
      );
    }
    if (localStorage.getItem("doctor_selected")) {
      let doctor = localStorage.getItem("doctor_selected");
      this.setState({ DoctorSelected: JSON.parse(doctor) });
    }
  }

  validate = () => {
    let NameError = "";
    let AgeError = "";
    let PhoneError = "";
    let TypeOfProblemHeSheIsFacingError = "";

    if (!this.state.Name) {
      NameError = "Name cannot be empty";
    }

    if (!this.state.Age) {
      AgeError = "Age cannot be empty";
    }
    if (!this.state.Phone) {
      PhoneError = "Phone number cannot be empty";
    }
    if (!this.state.TypeOfProblemHeSheIsFacing) {
      TypeOfProblemHeSheIsFacingError = "This field cannot be empty";
    }

    if (
      NameError ||
      AgeError ||
      PhoneError ||
      TypeOfProblemHeSheIsFacingError
    ) {
      this.setState({
        NameError,
        AgeError,
        PhoneError,
        TypeOfProblemHeSheIsFacingError,
      });
      return false;
    }

    return true;
  };
  onSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();

    if (isValid) {
      if (isValid && !this.state.checked) {
        toast.error("Please agree to the terms and conditions", {
          autoClose: 2000,
        });
        this.setState({
          NameError: "",
          AgeError: "",
          PhoneError: "",
          TypeOfProblemHeSheIsFacingError: "",
        });

        return;
      }
      let existingData = localStorage.getItem("emergency-appointment");
      existingData = JSON.parse(existingData);
      existingData.data.push({
        ...this.state,
        ...{ id: existingData.data.length + 1 },
      });
      localStorage.setItem(
        "emergency-appointment",
        JSON.stringify(existingData)
      );
      toast.info("Appointment Scheduled...!", {
        autoClose: 2000,
      });
      // clear form
      this.setState(initialState);
    }
  };
  render() {
    return (
      <>
        <div className={styles.backgroundappoint}>
          <Header name="Appointment" />
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}
          />

          <div className={basestyles.inputWidth}>
            <div className={styles.docName}>
              {this.state.DoctorSelected && (
                <div className={searchbar.doctorlist}>
                  <DoctorsNearby
                    doctor={{
                      Doctor: this.state.DoctorSelected.Doctor,
                      Speciality: this.state.DoctorSelected.Speciality,
                      Address: this.state.DoctorSelected.Address,
                    }}
                  />
                </div>
              )}
            </div>
            <form>
              <label className={styles.ptName}>Name</label>
              <Input
                placeholder="Name"
                type="text"
                name="Name"
                value={this.state.Name}
                onChange={(e) => this.inputchange(e)}
              />
              <div className={styles.errors}>{this.state.NameError}</div>

              <label className={styles.ptAge}>Age</label>
              <Input
                type="text"
                min="15"
                max="100"
                step="1"
                placeholder="ex: 22"
                name="Age"
                value={this.state.Age}
                onChange={(e) => this.inputchange(e)}
              />
              <div className={styles.errors}>{this.state.AgeError}</div>

              <label className={styles.ptphone}>Phone</label>
              <Input
                type="tel"
                placeholder="1-555-777-6666"
                name="Phone"
                value={this.state.Phone}
                onChange={(e) => this.inputchange(e)}
              />
              <div className={styles.errors}>{this.state.PhoneError}</div>

              <label className={styles.ptprob}>
                Type of Problem he/she is facing
              </label>
              <Textarea
                placeholder="Allergies, Colds and Flu, Headaches..etc"
                name="TypeOfProblemHeSheIsFacing"
                value={this.state.TypeOfProblemHeSheIsFacing}
                onChange={(e) => this.inputchange(e)}
              />
              <div className={styles.errors}>
                {this.state.TypeOfProblemHeSheIsFacingError}
              </div>

              <div className={styles.terms}>
                <div>
                  <input
                    type="checkbox"
                    checked={this.state.checked}
                    onClick={this.changeCheckedStatus}
                    style={{
                      height: "18px",
                      width: "18px",
                      cursor: "pointer",
                      verticalAlign: "middle",
                      marginTop: "10px",
                      marginLeft: "15px",
                    }}
                  />
                </div>
                <div>
                  <RecordBtn
                    btnName="I Agree to the terms and conditions"
                    onClick={(e) => this.openModal(e)}
                    style={{
                      color: "red",
                    }}
                  />
                </div>
                <Modal
                  isOpen={this.state.modalIsOpen}
                  style={{
                    overlay: {
                      background:
                        "linear-gradient( 60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
                    },
                    content: {
                      color: "#091135",
                      maxWidth: "600px",
                      margin: "0 auto",
                      padding: "25px",
                    },
                  }}
                >
                  <div className={styles.termsconditions}>
                    <h2>Terms and Conditions </h2>
                    <ul>
                      <li>
                        This appointment should be filled only in the emergency
                        Cases
                      </li>
                      <li>Fill out the perfect address to reach </li>
                      <li>
                        Extra Charges will be applied if we found the case is
                        not emergency
                      </li>
                    </ul>
                  </div>
                  <RecordBtn
                    btnName="Close"
                    onClick={() => this.closeModal()}
                    style={{
                      padding: "10px 50px",
                      margin: "10px",
                      fontSize: "1.1rem",
                    }}
                  />
                </Modal>
              </div>
              <Button
                onClick={(e) => this.onSubmit(e)}
                buttonName="Submit"
                style={{
                  color: "white",
                  margin: "20px 15px 30px",
                  padding: "10px 10px",
                  width: "90%",
                  maxWidth: "500px",
                }}
              ></Button>
              <ToastContainer />
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default EmergencyAppointments;
